
const itemMenuThreads = `
<a href="#" data-id="{{id}}" class="{{class_active}}">
	<span class="ajax-chat__threads__item__top">
		<span class="id">{{id}}</span>
		<span class="date-range">{{date_range}}</span>
		<span class="{{class_show}}">Nový</span>
	</span>
	<span class="ajax-chat__threads__item__middle">{{data}}</span>
	<span class="ajax-chat__threads__item__bottom">{{name}}</span>
</a>
`;

export default itemMenuThreads;